import { FC } from 'react';

import { CalendarIcon, MailIcon, PhoneIcon, UserIcon } from '@/components/icons';
import { CustomerDto } from '@/api';
import { StyledList } from '@/components';
import { formatDateTime } from '@/utils/dateTime';
import { getFullName } from '@/utils/helpers';

interface Props {
  customer: CustomerDto;
  showName?: boolean;
}

export const CustomerDetails: FC<Props> = ({ customer, showName = false }) => {
  const { dateOfBirth, email, mobileNumber, parentId } = customer;
  return (
    <StyledList>
      {showName && (
        <li>
          <h6>{getFullName(customer)}</h6>
        </li>
      )}
      <li>
        <img src={UserIcon} alt="User Icon" />
        {parentId ? 'Minor' : 'Adult'}
      </li>
      {dateOfBirth && (
        <li>
          <img src={CalendarIcon} alt="Calendar Icon" />
          {formatDateTime({ value: dateOfBirth })}
        </li>
      )}
      {email && (
        <li>
          <img src={MailIcon} alt="Mail Icon" />
          {email}
        </li>
      )}
      {mobileNumber && (
        <li>
          <img src={PhoneIcon} alt="Phone Icon" />
          {mobileNumber}
        </li>
      )}
    </StyledList>
  );
};
